export const DOWNLOAD_REPORT_CSV = "DOWNLOAD_REPORT_CSV";
export const FREE_SUBSCRIPTION_DATA = "FREE_SUBSCRIPTION_DATA";
export const GET_COURSES_REPORT = "GET_COURSES_REPORT";
export const GET_INDIVIDUAL_COURSES_REPORT = "GET_INDIVIDUAL_COURSES_REPORT";
export const GET_ALL_USER_REPORT = "GET_ALL_USER_REPORT";
export const GET_ALL_FREE_CLASS_REPORT = "GET_ALL_FREE_CLASS_REPORT";

export const GET_PRE_CLG_APPLICATION_SUBMITTED = "GET_PRE_CLG_APPLICATION_SUBMITTED";
export const TOTAL_ENTOLLMENT = "TOTAL_ENTOLLMENT";
export const COURSE_ENTOLLMENT = "COURSE_ENTOLLMENT";
export const SALES_COURSE_PURCHASE_DATA = "SALES_COURSE_PURCHASE_DATA";
export const SALES_PAYMENT_PENDING = "SALES_PAYMENT_PENDING";
export const SALES_OVERVIEW ="SALES_OVERVIEW";
export const GET_CERT_APPLICATION_SUBMITTED = "GET_CERT_APPLICATION_SUBMITTED";
export const TOTAL_CERT_ENTOLLMENT ="TOTAL_CERT_ENTOLLMENT"

export const GET_Dl_APPLICATION_SUBMITTED="GET_Dl_APPLICATION_SUBMITTED"; 
export const TOTAL_Dl_ENTOLLMENT="TOTAL_Dl_ENTOLLMENT";

export const SALES_APP_PURCHASE="SALES_APP_PURCHASE"